module.exports = __webpack_public_path__ + "img/eating contest.587c49d3.png";